import Vue from 'vue';
import VueRouter from 'vue-router';

import Impressum from './pages/Impressum.vue';
import Datenschutz from './pages/Datenschutz.vue';
import Home from './pages/Home.vue';
import RegistrationPage from './pages/RegistrationPage.vue';


Vue.use(VueRouter);

export default function createRouter() {
  const router = new VueRouter({
    base: '/',
    mode: 'history',
    routes: [
      {
        name: 'home',
        path: '/',
        component: Home,
      },
      {
        name: 'impressum',
        path: '/impressum',
        component: Impressum,
      },
      {
        name: 'datenschutz',
        path: '/datenschutz',
        component: Datenschutz,
      },
      {
        name: 'registration',
        path: '/registration',
        component: RegistrationPage,
      },
    ],
  });

  return router;
}
